// extracted by mini-css-extract-plugin
export default {"cartDropdownContainer":"BagDropdown_cartDropdownContainer__MY7pq","emptyMessage":"BagDropdown_emptyMessage__4eldd","cartItems":"BagDropdown_cartItems__Mp2tg"};